import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import vco from 'v-click-outside'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/assets/scss/app.scss'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(vco)
Vue.use(Vuelidate)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
